import { NewsCategory } from "@/@types";
import { ROUTES } from "@/config/routes";
import Link from "next/link";

type Props = {
  categories: NewsCategory[];
  selectedCategory?: string;
};

export default function NewsCategoryCard({ categories, selectedCategory }: Props) {
  return (
    <div className="flex-shrink-0 bg-white p-4">
      <h3 className="font-bold text-dark02 mb-4">CATEGORÍAS</h3>
      <div className="flex flex-wrap gap-3">
        <Link
          href={ROUTES.news.root}
          className="text-sm font-medium px-4 py-2 bg-light01 text-dark02 hover:bg-gray02"
        >
          TODAS
        </Link>
        {categories.map((category) => (
          <Link
            key={category.slug}
            href={ROUTES.news.categories(category.slug)}
            className={`text-sm font-medium px-4 py-2 ${selectedCategory === category.slug ? 'bg-gray02 text-dark01' : 'bg-gray-100 text-gray-700 hover:bg-gray02'}`}
          >
            {category.name.toUpperCase()}
          </Link>
        ))}
      </div>
    </div>
  );
}
